<template>
    <BaseCard v-if="themes.length > 0" padding="lg" class="flex flex-col gap-5">
        <div class="flex flex-col gap-1">
            <div class="nadia-subtitle text-ink">{{ title }}</div>
            <div class="body-small text-ink-muted">
                {{ t("reflections.campaignReport.themesSummary", { responses: responseCount, themes: themes.length }) }}
            </div>
        </div>
        <HorizontalDivider as="hr" spacing="none" />
        <div v-for="(theme, i) in themes" :key="`t-${i}`" class="flex flex-col gap-1 px-2.5">
            <span class="body-small-bold text-ink">{{ theme.title }}</span>
            <div class="flex items-stretch gap-2.5">
                <span class="w-1 rounded-full shrink-0 bg-insight-accent-dot" aria-hidden="true"></span>
                <p class="body-small text-ink-muted m-0">{{ theme.summary }}</p>
            </div>
        </div>
    </BaseCard>
</template>

<script setup lang="ts">
import BaseCard from "~vue/components/BaseCard.vue";
import HorizontalDivider from "~vue/components/HorizontalDivider.vue";
import { useI18n } from "vue-i18n";

interface Theme {
    title: string;
    summary?: string | null;
}

interface Props {
    title: string;
    responseCount: number;
    themes: Theme[];
}

defineProps<Props>();
const { t } = useI18n();
</script>
